export default {
  g: {
    common_name: 'Common Name',
    customer_type: 'Customer type',
    full_name: 'Full Name',
    first_name: 'First Name',
    last_name: 'Last Name',
    piva_cf: 'PIVA / C.Fisc',
    email: 'Email',
    work_phone: 'Work Phone',
    mobile_phone: 'Mobile Phone',
    address: 'Address',
    city: 'City',
    cap: 'ZIP',
    region: 'Region',
    state: 'Sate',
    created: 'Created',
    updated: 'Updated',
    removed: 'Removed',
    remove: 'Remove',
    details: 'Details',
    go_to_details: 'Go to Details',
    actions: 'Actions',
    manage: 'Manage',
    view: 'View',
    edit: 'Edit',
    delete: 'Delete',
    cancel: 'Cancel',
    id: '#',
    status: 'Status',
    ok: 'Ok',
    proced: 'Proced',
    confirm: 'Confirm',
    devices: 'Devices',
    tickets: 'Tickets',
    customer: 'Customer',
    platform: 'Platform',
    plan: 'Plan',
    plan_type: 'Plan Type',
    type: 'Type',
    os: 'OS',
    device: 'Device',
    phone_number: 'Phone Number',
    imei: 'IMEI',
    last_access: 'Last Access',
    mode: 'Mode',
    activity: 'Activity',
    category: 'Category',
    subcategory: 'Subcategory',
    schedule_date: 'Schedule Date',
    manage_date: 'Managed',
    managed_by: 'Managed by',
    closing_date: 'Closed',
    user: 'User',
    users: 'Users',
    email_desc: 'The email address used by the user for the login.',
    phone_number_desc: 'The customer phone number. Can be used as alternative username.',
    description: 'Description',

    valid_until: 'Valido until',
    date_creation: 'Creation date',
    date_opening: 'Opening date',
    date_activity: 'Activity date',
    duration: 'Duration',
    start_manage: 'Start assistance',
    resume_mange: 'Resume assistance',
    end_manage: 'Close assistance',

    assign_ticket: 'Assegn Ticket',
    reassign_ticket: 'Reassegn Ticket',
    close_ticket: 'Close ticket',
    reschedule_ticket: 'Reschedule Ticket',
    cancel_ticket: 'Cancel Ticket',
    resolution: 'Resolution',
    status_change: 'Update status',
    resolution_change: 'Update resolution',
    brand_model: 'Brand and Model',
    send: 'Send',
    start: 'Start',
    stop: 'Stop',
    remote_access: 'Remote Access',
    push_notification: 'Push Notification',

    subscriptions: 'Subscriptions',
    payment_method: 'Payment Method',
    date_start: 'Date start',
    date_expiration: 'Date expiration',
    date_next_payment: 'Next payment',
    reset_password: 'Reset password',
    add_users: 'Add users to current customer.',

    serial: 'Serial',
    model: 'Model',
    version: 'Version',
    last_login_at: 'Last access',
    last_activity_at: 'Last activity',
    installed_at: 'Installation date',
    has_error: 'In alarm',
    referent: 'Contact Person',

    name: 'Contact Person',
    provider: 'Provider',
    profile: 'Connectivity Profile',
    line_number: 'Landline num.',
    updated_at: 'Last update',
    online_since: 'Online since',
    last_activity: 'Last Activity',
    last_startup: 'Last Startup',
    sim_iccid: 'SIM ICCID',
    has_warning: 'Has Warning',

    logged_at: 'Logged',
    level: 'Level',
    event: 'Event',
    events: 'Events',
    open_ticket: 'Open Ticket',
    monitored: 'Monitored',
    warning: 'Warning',
    loading_message: 'Loading Data... Please wait.',
    choice_lang: 'Change Lang',
    is_online: 'Online',
    search: 'Search',
    filter: 'Filter',

    level_low: 'Low',
    level_medium: 'Medium',
    level_high: 'High',
  },
};



// WEBPACK FOOTER //
// ./src/locales/en.js